export enum DisplayMode {
  HIERARCHICAL = 'HIERARCHICAL',
  INDIVIDUAL = 'INDIVIDUAL',
}
